export const PATH_APP = {
  home: "/",
  login: "/login",
  portfolio: "/cartera",
  valuation: "/cartera/valuacion",
  returns: "/cartera/evolucion",
  reports: "/cartera/reportes",
  transactions: "/transferencias",
  activity: "/actividad",
  profile: "/perfil",
  help: "/ayuda",
  market: "/mercado",
  favorites: "/favoritos",
  instrument: "/instrumento-detalle",
  research: "/research",
  searchInstruments: "/mercado/buscar",
  searchFavorites: "/favoritos/buscar",
  notFound: "*",
};
